import { useQuery } from "@tanstack/react-query";
import apiFastifyClient from "./apiFastifyCloud";
import { QueryParamValue, toQueryString } from "src/utils";
import { ITransReportsData } from "src/types/business-intelligence";

interface IParams {
  locations?: string[];
  cities?: string[];
  userId?: string;
  startDate?: string | number;
  endDate?: string | number;
  locationType?: string
}

export const useGetBISummary = (params: IParams) =>
  useQuery<IParams, any, { data: ITransReportsData }>({
    queryKey: [
      "get-bi-summary",
      params.startDate,
      params.endDate,
      params.locations,
      params.userId,
      params.cities,
      params.locationType
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/combined?${queryString}`
      );
    },
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });
